export { default } from './SpeedDialAction';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/SpeedDialAction/index.js
// module id = 889
// module chunks = 2